(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('PlanningRestrictPeriodController', PlanningRestrictPeriodController);

    PlanningRestrictPeriodController.$inject = ['entity', 'AlertService', 'SoopkitchenUtils', 'PlanningEventsService'];

    function PlanningRestrictPeriodController(entity, AlertService, SoopkitchenUtils, PlanningEventsService) {

        var vm = this;

        vm.plan = entity;
        vm.cancel = cancel;
        vm.collectionsStart = vm.plan.eventCollections.validityStartTime;
        vm.collectionsEnd = vm.plan.eventCollections.validityEndTime;
        vm.planStart = vm.plan.validityStartTime;
        vm.planEnd = vm.plan.validityEndTime;
        vm.isValidDate = SoopkitchenUtils.isValidDate;
        vm.picker = {};
        vm.picker2 = {};
        vm.reset = reset;
        vm.apply = apply;
        vm.updateLetters = updateLetters;
        vm.durationLettersInvalid = durationLettersInvalid;
        vm.invalidDateRange = invalidDateRange;
        vm.updateEndDate = updateEndDate;
        vm.updateDuration = updateDuration;
        /**** Main ****/

        vm.picker = {date: vm.plan.validityStartTime.substring(0, 10)};
        vm.picker2 = {date: vm.plan.validityEndTime.substring(0, 10)};

        vm.duration = (Date.parse(vm.picker2.date) - Date.parse(vm.picker.date)) / 1000;
        vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
        
        updateDuration();

        function cancel() {
            location.reload();
        }

        function reset() {
            vm.picker.date = vm.planStart.substring(0, 10);
            vm.picker2.date = vm.planEnd.substring(0, 10);
            vm.duration = (Date.parse(vm.picker2.date) - Date.parse(vm.picker.date)) / 1000;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
        }

        function updateLetters() {
            if(SoopkitchenUtils.isValidDate(vm.picker.date) && vm.durationLetters) {
                vm.duration = SoopkitchenUtils.timeToSeconds(vm.durationLetters);
                var newDate = new Date(Date.parse(vm.picker.date).valueOf() + vm.duration * 1000);
                vm.picker2 = {date: SoopkitchenUtils.formattedDate(newDate).substring(0, 10)};
            }
        }

        function updateEndDate() {
            if(SoopkitchenUtils.isValidDate(vm.picker.date)) {
                var newDate = new Date(Date.parse(vm.picker.date).valueOf() + vm.duration * 1000);
                vm.picker2 = {
                    date: SoopkitchenUtils.formattedDate(newDate).substring(0, 10)
                };
            }
        }

        function invalidDateRange() {
            if(SoopkitchenUtils.isValidDate(vm.picker.date) && SoopkitchenUtils.isValidDate(vm.picker2.date)) {
                var endDateMilliseconds = Date.parse(vm.picker2.date).valueOf();
                var startDateMilliseconds = Date.parse(vm.picker.date).valueOf();
                return startDateMilliseconds > endDateMilliseconds;
            } else {
                return false;
            }
        }

        function durationLettersInvalid() {
            if (vm.durationLetters == null) {
                return false;
            } else {
                return (SoopkitchenUtils.timeToSeconds(vm.durationLetters) === 0 || isNaN(SoopkitchenUtils.timeToSeconds(vm.durationLetters)));
            }
        }

        function updateDuration() {
            if(SoopkitchenUtils.isValidDate(vm.picker.date) && SoopkitchenUtils.isValidDate(vm.picker2.date)) {
                vm.duration = (Date.parse(vm.picker2.date) - Date.parse(vm.picker.date)) / 1000;
                vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            }
        }

        function apply() {
            PlanningEventsService.setValidityPeriod(
                {
                    planLabel: vm.plan.label,
                    startTime: vm.picker.date,
                    endTime: vm.picker2.date
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You have changed the planning period of " + vm.plan.label, "success");
                    location.reload();
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                });
        }
    }
})();
